import React from 'react';

export default function ProfileImage({ src, placeholder }) {
  return (
    <div className="as-ProfileImage">
      {src ? (
        <img
          alt="Profile"
          className="as-ProfileImage-image"
          id="asHeaderProfileImage"
          src={src}
        />
      ) : (
        placeholder
      )}
    </div>
  );
}
